<template>
  <div>
    <el-row style="margin-bottom:10px;">
      <el-col :span="4">
        <el-select v-if="theProjectId == 0" v-model="form.projectId" @change="theProjectAllChange" size="small" filterable
          clearable placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>

      </el-col>
      <el-col :span="10" class='flex'>
        <el-select v-model="getUserVisitorPropertyList_data.yuvpType" v-change.getUserVisitorPropertyList size="small"
          filterable clearable>
          <el-option label="官方" :value="1">
          </el-option>
          <el-option label="非官方" :value="2">
          </el-option>
        </el-select>
        <el-input v-model="getUserVisitorPropertyList_data.yuvpName" placeholder="请输入物业名" clearable size='small'
          style="max-width:380px;" />
        <el-button v-click.getUserVisitorPropertyList type="primary" icon='el-icon-search' size='small'
          style='margin-left:10px;'>搜索
        </el-button>
      </el-col>
      <el-col :span="10">

        <el-button v-if="addUserVisitorProperty" @click="$form('addUserVisitorProperty')" size='small' type="primary"
          style="float:right" icon='el-icon-circle-plus'>添加物业
        </el-button>
        <el-button v-if="addUserVisitorProperty" @click=" $form('addMultiUsersAll'), tabledataAll = [], row = {}"
          size='small' type="primary" style="float:right;margin-right: 20px;" icon='el-icon-circle-plus'>批量导入物业
        </el-button>
        <el-dropdown size='small' split-button type="warning" style="margin-left: 10px;width: 100px;" @click="Out()"
                    @command="Out">
                    导出
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item style="background-color: #E6A23C;color: white;"
                            command="1">导出全部</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
      </el-col>
    </el-row>

    <mytable :tableColums='tableColums_getUserVisitorPropertyList' api='getUserVisitorPropertyList ::yuvpId'
      xupdateapi='updateUserVisitorProperty' :height="H - 165" ref="getUserVisitorPropertyListTable">
    </mytable>

    <myform :viewobj='{
      addUserVisitorProperty: ["新增物业信息", "el-icon-circle-plus"],
      updateUserVisitorProperty: ["修改物业信息", "el-icon-edit-outline"],
      $succeed$: getUserVisitorPropertyList
    }'
      @close="$form('addUserVisitorProperty', 'reset'); window.sleep(50, v => Myformdata && (userkey = userkey2, Networdarr = Networdarr2))"
      @confirm='myform'>
      <template v-for="(item, index) in DiyList.visitorCustomizeProperty">
        <div style="display: flex;margin: 20px 0;">
          <div style="margin:0 20px;width: 20%;text-align: right;">{{ item.yuvceLabel }}</div>
          <div style="width: 80%;">
            <el-input v-model="formBuilding[item.yuvceKey]" style="width: 100%;" size="small"
              @input="$forceUpdate()"></el-input>
          </div>
        </div>
      </template>
      <hide slot='yuvpId' />
    </myform>
    <myform view.addMultiUsersAll="批量导入物业" @close='$form("addMultiUsersAll", "hide")'>
      <el-row>
        <el-col :span="4" style="min-width:100px;">
          <el-button type="primary" @click="toDownExcel">下载<i class="el-icon-download el-icon--right"></i></el-button>
        </el-col>
        <el-col :span="20">
          <el-upload ref="uploadAll" action="#" :limit="1" :auto-upload="false" :show-file-list="true"
            :on-change="onChangeContent">
            <el-button type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
          </el-upload>
        </el-col>
      </el-row>
      <el-table :data="tabledataAll" v-if="(tabledataAll || '').length > 0" max-height="400">
        <el-table-column prop="status" label="状态" width="120">
        </el-table-column>
        <el-table-column prop="statusMsg" label="原因" width="120">
        </el-table-column>

        <el-table-column prop="yuvpName" label="物业">
        </el-table-column>
        <el-table-column prop="yuvpNetworkNum" label="网络条数">
        </el-table-column>
        <el-table-column prop="yuvpNetworkMoney" label="网络总费用">
        </el-table-column>
        <el-table-column prop="yuvpFixedlineOperator" label="固话所属运营商" width="120">
        </el-table-column>
        <el-table-column prop="yuvpFixedlineNum" label="固话数量" width="120">
        </el-table-column>
        <el-table-column prop="yuvpFixedlineExpirationDate" label="固话到期时间 " width="120">
        </el-table-column>
        <el-table-column prop="yuvpFixedlineMoney" label="固话总费用" width="120">
        </el-table-column>
        <el-table-column prop="yuvpTotalMoney" label="业务总支出" width="120">
        </el-table-column>
        <el-table-column prop="yuvkName" label="关键人姓名" width="120">
        </el-table-column>
        <el-table-column prop="yuvkPost" label="职位" width="120">
        </el-table-column>
        <el-table-column prop="yuvkContract" label="联系方式" width="120">
        </el-table-column>
        <el-table-column prop="yuvkOperator" label="号卡所属运营商" width="120">
        </el-table-column>
        <el-table-column prop="yuvnOperator" label="网络所属运营商" width="120">
        </el-table-column>
        <el-table-column prop="yuvnBandwidth" label="带框" width="120">
        </el-table-column>
        <el-table-column prop="yuvnExpirationDate" label="到期时间" width="120">
        </el-table-column>
        <el-table-column prop="yuvnMoney" label="费用" width="120">
        </el-table-column>

      </el-table>
      <div style="width:100%; margin: 60px auto 20px;text-align: right;">
        <!-- <el-button @click="bulkImportClose">取 消</el-button> -->
        <el-button type="success" @click="bulkImportClick">确定导入</el-button>
      </div>
    </myform>
    <myform view.getUserVisitorPropertyDetails='详情' @opened="">

      <el-descriptions v-if="getUserVisitorPropertyDetails_data.data" :column="1" border :labelStyle="{
        color: '#409EFF',
        textAlign: 'center',
        width: '20%',
        fontSize: '12px'
      }" :contentStyle="{ textAlign: 'left', width: '80%', fontSize: '12px' }">
       
        <el-descriptions-item label="物业名称">{{ getUserVisitorPropertyDetails_data.data.yuvpName }}</el-descriptions-item>
        <template v-for="(item, index) in DiyList.visitorCustomizeProperty">
          <el-descriptions-item :label="item.yuvceLabel">{{ formDetail[item.yuvceKey] }}</el-descriptions-item>
        </template>
      </el-descriptions>
      <hide slot='yuvpId' />
    </myform>
  </div>
</template>
  
<script>
import myhttp from '../../utils/myhttp';
import qs from 'qs';
import axios from 'axios';
export default {
  data() {
    return {
      baseUrl: $Api.baseUrl_online,

      formDetail: {},
      formBuilding: {},
      DiyList: [],
      tabledata: [],
      tabledataAll: [],
      form: {
        projectId: null,
      },
      userkey: [
        {
          yuvkId: '',
          yuvkType: 1,
          yuvkTypeId: '',
          yuvkName: '',
          yuvkPost: '',
          yuvkContract: '',
          yuvkOperator: '',
          id: 1,
        }
      ],
      userkey2: [
        {
          yuvkId: '',
          yuvkType: 1,
          yuvkTypeId: '',
          yuvkName: '',
          yuvkPost: '',
          yuvkContract: '',
          yuvkOperator: '',
          id: 1,
        }
      ],
      Networdarr: [{
        yuvnId: '',
        yuvnType: 1,
        yuvnTypeId: '',
        yuvnOperator: '',
        yuvnBandwidth: '',
        yuvnExpirationDate: '',
        yuvnMoney: '',
      }],
      Networdarr2: [{
        yuvnId: '',
        yuvnType: 1,
        yuvnTypeId: '',
        yuvnOperator: '',
        yuvnBandwidth: '',
        yuvnExpirationDate: '',
        yuvnMoney: '',
      }],

      attrId: null,
      theHasKey: 1,
      tableColums_getUserVisitorPropertyList: {
        $selection: true,



        yuvpName: '物业名称',
        createtime: '创建时间',

        $operation: [
          '操作', 200,
          this.updateUserVisitorProperty && `@text: 编辑#success
             @click:Edit($row)
            `,
          this.deleteUserVisitorProperty && `@text: 删除#danger
             @click: _confirm('确定要删除该物业吗?')
                     .trigger('deleteUserVisitorProperty',{yuvpIds:$row.yuvpId})
                     .trigger('getUserVisitorPropertyList')
            `,
            this.getUserVisitorPropertyDetails && `@text: 详情#success
             @click:Detail($row)
            `,
        ],

      },

    };
  },

  watch: {

  },

  methods: {
    openLoading() {
            //loading请求等待
            this.loading = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out(e) {
           
            // if(!this.thepvcId){
            //   this.$message({message: '请先选择拜访分类在导出', type: 'warning' });
            //   return;
            // }
            if (e) {
                const bulkdata = {
                    projectId: this.theProjectId,
                    yuvbcId:this.getUserVisitorPropertyList_data.yuvbcId,
                    yuvpType:this.getUserVisitorPropertyList_data.yuvpType,
                    yuvpName:this.getUserVisitorPropertyList_data.yuvpName,
                    exportType: 1,
                    
                }
                this.openLoading();
                var s = qs.stringify(bulkdata);
                var that = this
                axios({
                    method: 'post',
                    url: that.baseUrl + '/opportunity/user-visitor-property/exportUserVisitorProperty',
                    data: s,
                    withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'token': A.local('$Usertoken'),
                        'projectId': +A.local('$projectId'),
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loading.close();
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '物业.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });
                       
                    }
                })
            } else {
                const selection = Object.keys(this.$refs.getUserVisitorPropertyListTable.$MyTableCache);
                if (selection.length === 0) return alertWarn('请选择您要导出的数据！');

                console.log(selection.join());
                const bulkdata = {
                    projectId: this.theProjectId,
                    yuvbcId:this.getUserVisitorPropertyList_data.yuvbcId,
                    yuvpType:this.getUserVisitorPropertyList_data.yuvpType,
                    yuvpName:this.getUserVisitorPropertyList_data.yuvpName,
                    exportType: 2,
                   
                    yuvpIds: selection.join()
                }
                this.openLoading();
                var s = qs.stringify(bulkdata);
                var that = this
                axios({
                    method: 'post',
                    url: that.baseUrl + '/opportunity/user-visitor-property/exportUserVisitorProperty',
                    data: s,
                    withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'token': A.local('$Usertoken'),
                        'projectId': +A.local('$projectId'),
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loading.close();
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '物业.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });
                        that.BulkClose()
                    }
                })
            }
        },
    Detail(row) {
            this.getUserVisitorPropertyDetails({ yuvpId: row.yuvpId }).result(res => {
                const data = res.data.data;
                for (let key in this.formDetail) {
                    for (let dataKey in res.data.data) {
                        if (key == dataKey) {
                            this.formDetail[key] = res.data.data[dataKey]
                        }
                    }
                }
                this.$form("getUserVisitorPropertyDetails", data);
                console.log(this.formDetail);
            })
        },
        Edit(row) {
            this.getUserVisitorPropertyDetails({ yuvpId: row.yuvpId }).result(res => {
                const data = res.data.data;
                for (let key in this.formBuilding) {
                    for (let dataKey in res.data.data) {
                        if (key == dataKey) {
                            this.formBuilding[key] = res.data.data[dataKey]
                        }
                    }
                }
                this.$form("updateUserVisitorProperty", data)
            })
        },
        myform(submit, Myformdata) {
            console.log(Myformdata);
            for (let key in this.formBuilding) {
                Myformdata[key] = this.formBuilding[key];
                this.formBuilding[key] = '';
            };
            submit();
            console.log(Myformdata);
        },
    bulkImportClick() {
      if (this.tabledata.sitId == '') {
        this.$message({
          showClose: true,
          message: "请导入资料",
          type: 'danger'
        });
      } else {
        this.uploadImportVisitorProperty({
          sitId: this.tabledata.sitId
        })
        this.$message({
          type: 'success',
          message: '导入成功!'
        });
        this.$form("addMultiUsersAll", "hide")
      }

    },
    doupload: async function (file) {
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      if (this.row && this.row.projectId) {
        param.append("projectId", this.row.projectId);
      }
      console.log(param)
      const loading = $Loading();
      const responseData = await myhttp.postFileUsers("/opportunity/user-visitor-property/uploadUserVisitorProperty", param);
      loading.close();
      if (responseData.data.result == "success") {
        this.$message({
          type: "success",
          message: "上传成功!"
        });
      } else {
        this.$message({
          type: "error",
          message: "上传失败!"
        });
      }
      return responseData
    },
    async onChangeContent(files, fileList) {
      const table = await this.doupload(files.raw);
      this.tabledata = table.data.data.data.sysImportTem;
      this.tabledataAll = table.data.data.data.resultList;
      //    this.getUserTargetList();
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();  //清空文件
      }
      if (this.$refs.uploadAll) {
        this.$refs.uploadAll.clearFiles();  //清空文件
      }
    },
    toDownExcel() {
      myhttp.downloadFile("https://trainapp.aojuai.com/trainai/excel/property.xlsx", "物业.xlsx");
    },
    async handelEdit(row) {
      this.getUserVisitorPropertyDetails({ yuvpId: row.yuvpId }).result((res) => {
        console.log(res);
        if (res.data.data) {
          const obj = res.data.data;
          this.userkey = obj.userVisitorKeyuserList;
          this.Networdarr = obj.userVisitorNetworkList;
          // this.VideoArr = obj.microlectureParagraphList;
          this.$form("updateUserVisitorProperty", obj);
        }
      });
    },
    
    adduserkey() {
      this.userkey.push({
        yuvkId: '',
        yuvkType: 1,
        yuvkTypeId: '',
        yuvkName: '',
        yuvkPost: '',
        yuvkContract: '',
        yuvkOperator: '',

      })
    },
    deluserKey(index) {
      if (this.userkey.length == 1) {
        return;
      }
      this.userkey.splice(index, 1);
    },
    addNetwordarr() {
      this.Networdarr.push({
        yuvnId: '',
        yuvnType: 1,
        yuvnTypeId: '',
        yuvnOperator: '',
        yuvnBandwidth: '',
        yuvnExpirationDate: '',
        yuvnMoney: '',
      })
    },
    delNetwordarr(index) {
      if (this.Networdarr.length == 1) {
        return;
      }
      this.Networdarr.splice(index, 1);
    },
    theProjectAllChange(e) {
      if (e == '') {
        return this.form.projectId = e;
      }
      this.form.projectId = e;
      this.getUserVisitorPropertyList({ projectId: this.form.projectId })
    },
  },

  created() {
    this.getProjectList({
      pageSize: 0
    });

    this.theProjectId = A.local("$projectId");
    if (this.theProjectId != 0) {
      this.form.projectId = this.theProjectId;
    }
    this.getUserVisitorCustomizeMapList({ projectId: this.theProjectId }).result(res => {
            this.DiyList = res.data.data;
            res.data.data.visitorCustomizeProperty.forEach(element => {
                if (element.yuvceShow == 2) {
                    this.formBuilding[element.yuvceKey] = '';
                    this.formDetail[element.yuvceKey] = '';
                }

            });
            console.log(this.formBuilding);
        })
    this.getUserVisitorPropertyList();
  }
};
</script>
  
<style scoped></style>
  


// WEBPACK FOOTER //
// src/views/help/PropertyMent.vue